<footer class="hb-footer">
  <div class="hb-container hb-container--width-lg">
    <div class="hb-grid">
      <div class="hb-cell hb-cell--12of12 hb-cell--4of12@md">
        <h2 class="hb-footer-tittel">Om nettsiden</h2>
        <ul class="hb-list hb-list--minimal">
          <li>
            <a class="hb-footer-lenke" href="https://husbanken.no/om-husbanken/personvern/">Personvern</a>
          </li>
          <li>
            <a class="hb-footer-lenke" target="_blank" href="https://uustatus.no/nb/erklaringer/publisert/39b08738-d2dd-4948-9f4f-1feefc10ffcd">
              Tilgjengelighetserklæring
              <span class="hb-screenreader-only">åpnes i nytt vindu</span>
              <span class="hb-icon hb-icon--size100" aria-hidden="true">
                <svg focusable="false">
                  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/sprite.symbol.svg#icon-expand-6"></use>
                </svg>
              </span>
            </a>
          </li>
        </ul>
      </div>
      <div class="hb-cell hb-cell--12of12 hb-cell--4of12@md">
        <h2 class="hb-footer-tittel">Kontakt</h2>
        <ul class="hb-list hb-list--minimal">
          <li>
            <a class="hb-footer-lenke" target="_blank" href="https://husbanken.no/om-husbanken/kontakt/"
              >Kontakt Husbanken
              <span class="hb-screenreader-only">åpnes i nytt vindu</span>
              <span class="hb-icon hb-icon--size100" aria-hidden="true">
                <svg focusable="false">
                  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/sprite.symbol.svg#icon-expand-6"></use>
                </svg>
              </span>
            </a>
          </li>
          <li>
            <a class="hb-footer-lenke" target="_blank" href="https://husbanken.no/om-husbanken/kontakt/vare-kontor/"
              >Våre kontorer
              <span class="hb-screenreader-only">åpnes i nytt vindu</span>
              <span class="hb-icon hb-icon--size100" aria-hidden="true">
                <svg focusable="false">
                  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/sprite.symbol.svg#icon-expand-6"></use>
                </svg>
              </span>
            </a>
          </li>
          <li>
            <a class="hb-footer-lenke" href="https://husbanken.no/om-husbanken/jobb/" target="_blank"
              >Ledige stillinger
              <span class="hb-screenreader-only">åpnes i nytt vindu</span>
              <span class="hb-icon hb-icon--size100" aria-hidden="true">
                <svg focusable="false">
                  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/sprite.symbol.svg#icon-expand-6"></use>
                </svg>
              </span>
            </a>
          </li>
        </ul>
        <div class="footer-sosial">
          <a class="hb-footer-lenke hb-footer-sosial" target="_blank" href="https://www.facebook.com/husbanken/" title="Facebook">
            <hb-icon iconId="social-media-facebook-1" size="100" class="sosialIkon"></hb-icon>
          </a>
          <a class="hb-footer-lenke hb-footer-sosial" target="_blank" href="https://www.linkedin.com/company/husbanken/" title="LinkedIn">
            <hb-icon iconId="professional-network-linkedin" size="100" class="sosialIkon"></hb-icon>
          </a>
          <a class="hb-footer-lenke hb-footer-sosial" target="_blank" href="https://twitter.com/husbanken" title="Twitter">
            <hb-icon iconId="social-media-twitter" size="100" class="sosialIkon"></hb-icon>
          </a>
          <a class="hb-footer-lenke hb-footer-sosial" target="_blank" href="https://vimeo.com/husbanken" title="Vimeo">
            <hb-icon iconId="social-video-vimeo" size="100" class="sosialIkon"></hb-icon>
          </a>
        </div>
      </div>
      <div class="hb-cell hb-cell--12of12 hb-cell--4of12@md">
        <h2 class="hb-footer-tittel">Snarveier</h2>
        <ul class="hb-list hb-list--minimal">
          <li>
            <a class="hb-footer-lenke" href="hjelp/om">Om Statistikkbanken</a>
          </li>
          <li>
            <a class="hb-footer-lenke" href="https://einnsyn.no/sok?stat0=http%3A%2F%2Fdata.einnsyn.no%2Fvirksomhet%2Foepeksport_content_provider_108" target="_blank"
              >Offentlig journal
              <span class="hb-screenreader-only">åpnes i nytt vindu</span>
              <span class="hb-icon hb-icon--size100" aria-hidden="true">
                <svg focusable="false">
                  <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="assets/sprite.symbol.svg#icon-expand-6"></use>
                </svg>
              </span>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</footer>
